import { render, staticRenderFns } from "./v-5.vue?vue&type=template&id=e1936eb4&scoped=true&"
import script from "./v-5.vue?vue&type=script&lang=js&"
export * from "./v-5.vue?vue&type=script&lang=js&"
import style0 from "./v-5.vue?vue&type=style&index=0&id=e1936eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1936eb4",
  null
  
)

export default component.exports